import { PlusIcon } from '@heroicons/react/24/outline'

import { Modal } from '../common/Modal'
import { useCustomChartContext } from './CustomChartState'
import { CurrentStep } from './CurrentStep'

export const CustomChartModal = () => {
  const {
    dispatch,
    state: { showModal },
  } = useCustomChartContext()
  const onClose = () => {
    dispatch({ type: 'RESET' })
  }
  return (
    <Modal
      hideHeader
      isOpen={showModal}
      onClose={onClose}
      onOpen={() =>
        dispatch({ type: 'SET_SHOW_MODAL', payload: { showModal: true } })
      }
      renderButton={(onClick) => (
        <button
          onClick={() => onClick()}
          type="button"
          className="py-2 px-2.5 rounded-md border border-gray-300 hover:bg-slate-50 text-sm font-medium flex gap-2 items-center h-full bg-white shadow-sm active"
        >
          <PlusIcon className="h-4 inline-block" />
        </button>
      )}
      className="w-full h-full flex flex-col justify-between overflow-y-scroll relative"
    >
      <CurrentStep />
    </Modal>
  )
}
